module.exports = __webpack_public_path__ + "img/field_1.37fc80ff.jpg";